import { ReadOnlyPrice } from "./ReadOnlyPrice";
export default ReadOnlyPrice;



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/ReadOnlyPrice/index.js